import { swBackspace } from './sw-backspace';
import { swCapitalize } from './sw-capitalize';
import { swEmail } from './sw-email';
import { swFocus } from './sw-focus';
import { swFocusEmpty } from './sw-focus-empty';
import { swInteger } from './sw-integer';
import { swNumber } from './sw-number';
import { swType } from './sw-type';

export function addDirectives(sharedModule) {
  swBackspace(sharedModule);
  swCapitalize(sharedModule);
  swEmail(sharedModule);
  swFocus(sharedModule);
  swFocusEmpty(sharedModule);
  swInteger(sharedModule);
  swNumber(sharedModule);
  swType(sharedModule);
}
